import React from 'react';
import './theme.css';

export default class IfsEditor extends React.Component {
  /*constructor(props)
  {
    super(props);
  }*/

  render(){
    return (
      <div className="ablak">
        <div className="keret">
          <h1>IFS Node Editor</h1>
          <p>Software for designing the xaos structure of flame fractals.</p>
          <img src="images/xaos.gif" alt="" style={{width: '20.0vw'}}/>
        </div>
        <div className="keret szovegdoboz">
          <h3>Features: (currently wip)</h3>
          <ul>
            <li>Fluxogram-sytle node editor: easily edit the connections between xforms</li>
            <li>Auto-generated layouts: untangle nodes for better visibility</li>
            <li>Import/export flame: compatibility with Apophysis7X</li>
          </ul>
        </div>
        <div className="keret szovegdoboz">
          <h3>Planned:</h3>
            <ul>
              <li>Grouping, pre/post-affine editing, Chaotica import/export, undo function</li>
              <li>Message me for feature requests, ideas - <i><a data-email="bezozo97@gmail.com" href="mailto:bezozo97@gmail.com">Contact me</a></i></li>
            </ul>
        </div>
        <div className="keret szovegdoboz">
          <h3>Usage:</h3>
          <ul>
            <li>Click the Import button to read Apophysis7X flame parameters from clipboard</li>
            <li>Choose one of the layout options if nodes are tangled</li>
            <li>Left double click on empty space to place a new xform</li>
            <li>Left click on xform to edit its properties: name, weight, opacity, variations</li>
            <li>Left click on a connection's arrow to edit weight value</li>
            <li>Left drag to make a connection between two xform</li>
            <li>Left drag from/to empty space to add linked xform</li>
            <li>Right double click to remove xform or connection</li>
            <li>Right drag an xform to move position</li>
            <li>Click the Export button to generate Apophysis7X flame parameters to clipboard.</li>
            <li>It'll be pasted into Apophysis7X-16 32bit if it's open.</li>
            <li>Hold Ctrl + scroll mouse to resize nodes</li>
          </ul>
        </div>
        <div className="keret szovegdoboz">
          <h3>Navigation:</h3>
          <ul>
            <li>Right drag on empty space to move around</li>
            <li>Mouse scroll to zoom in/out</li>
          </ul>
        </div>
        <div className="keret szovegdoboz">
          <h3>Requirements:</h3>
            <ul>
              <li>Windows with .Net framework (already installed on newer versions)</li>
            </ul>
        </div>
        <div className="keret">
          {/*<b>Download:</b><br>
          .zip file containing the executable and readme<br>
          <a href="https://app.box.com/s/jb6llxe92pou7wq1lfe9nv28fg2lymso" target="_blank"><i class="material-icons gomb" style="padding: 10px 100px 10px 100px; text-align: center; font-size:48px;">file_download</i></a><br>
          last update: 2017.10.23.*/}
          <p>New version work in progress, contact me for questions. 2018.03.23.</p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Component/IfsEditor.js